import { getChannelHost } from 'src/utils/messages/singleton'
import { installModalForwarder, registerModal } from 'src/utils/messages/modalChannel'

import { createAbandonedCart } from 'src/widgets/embed/abandonedCart'
import { renderDialog, renderModal, closeDialog } from 'src/widgets/embed/dialog'
import { dispatchOpenModal } from 'src/widgets/embed/openModal'

// Side-effect module: bootstraps the abandoned-cart manager when the
// donate widget is at the top frame (no embed-script host in play).
// Imported by the donate-v6 pack so the manager is set up before
// React mounts and starts announcing engagement.
//
// In modes 2 + 3 (iframe-embedded) the partner page's embed script
// already runs its own manager; the donate iframe sends signals over
// the channel. Skip the setup here for those modes so we don't end
// up with two managers fighting over triggers.
//
// We also stand up a channel host here so the corner-dialog iframe
// can reach us with openModal messages. Without that, openModal's
// fallback path renders the org modal inside the 320px-wide corner
// dialog iframe — unusable. With the host in place, the corner
// dialog's channel handshake succeeds and the modal renders at the
// top frame (this donate widget) at full size. Same-origin
// resizeIframe inside the modal iframe handles height sync
// directly via frameElement, no extra wiring needed.
//
// dispatchOpenModal lets a registered handler intercept particular
// ids (none today at the donate-widget level, but the hook is the
// same one Widgets.js#init runs); onUnhandled is the existing
// renderModal default.
if (parent === self) {
  const host = getChannelHost({ origin: location.origin })
  installModalForwarder(host)
  host.onAll('openModal', (opts, _meta, opener) => {
    dispatchOpenModal(opts, {
      onUnhandled: opts => {
        const result = renderModal(opts)
        if (result) {
          host.register(result.iframe)
          registerModal({ ...result, opener })
        }
      },
    })
  })

  createAbandonedCart({
    onFire: opts => {
      const result = renderDialog(opts)
      if (!result) return
      host.register(result.iframe)
      // Return a closer so the manager can dismiss this dialog when the
      // donation completes (mode 1 routes donationCompleted straight to
      // the local manager via getAbandonedCart()).
      return () => closeDialog(result.dialog)
    },
  })
}
